import { DataType } from "./AnalyticsTracker";
import { LoginResponseUser } from "@api-types/user/LoginResponseDto";
import { UserTypeEnum } from "@data-types/analytics-tracker/AnalyticsTrackerEnum";
import {
	GA_INTERNAL_REQUIRES_CONSENT,
	isAnalyticsConsentSatisfied,
} from "./cookieConsentConfig";

export class GoogleAnalyticsProvider {
	private isGAEnabled(): boolean {
		return WEBPACK_ANALYTICS_PROVIDERS.includes("ga-web");
	}

	private hasConsent(): boolean {
		return isAnalyticsConsentSatisfied(
			GA_INTERNAL_REQUIRES_CONSENT,
			"analytics"
		);
	}

	constructor() {}

	public setUserId(userData: LoginResponseUser) {
		if (!this.isGAEnabled()) {
			return;
		}
		if (!this.hasConsent()) {
			return;
		}
		if (!userData) {
			console.error("Missing user data from local storage");
			return;
		}

		try {
			if (!userData.id || !userData.agencyId) {
				console.error("Missing userId or agencyId");
				return;
			}

			window.gtag?.(
				"set",
				"user_id",
				`${userData.agencyId}_${userData.id}`
			);

			window.gtag?.("set", "user_properties", {
				user_type: App.state.rootStore.userAuthStore.isInternetUser
					? UserTypeEnum.Online
					: UserTypeEnum.Retail,
			});
		} catch (error) {
			console.error(
				"Error with shooting google analytics setUserId",
				error
			);
			return;
		}
	}

	public trackEvent(eventName: string, data: DataType) {
		if (!this.isGAEnabled()) {
			return;
		}
		if (!this.hasConsent()) {
			return;
		}

		const checkGtagAndDataLayer = () => {
			if (window.dataLayer) {
				window.gtag?.("event", eventName, data);
			} else {
				setTimeout(checkGtagAndDataLayer, 500);
			}
		};

		checkGtagAndDataLayer();
	}
}
